














































import Vue from "vue";

export default Vue.extend({
  name: "AddHabit",
  data() {
    return {
      weekLetter: ["S", "M", "T", "W", "T", "F", "S"],
      habitForm: {
        id: `_${new Date().getTime() + Math.floor(Math.random() * 10000)}`,
        name: "",
        acomplishments: [],
        notes: [],
        repeatsOn: [false, true, true, true, true, true, false],
      },
      errorMessage: "",
    };
  },
  mounted() {
    document.getElementById("add-habit-name-input")?.focus();
  },
  methods: {
    handleBackClick(): void {
      this.$router.push("/");
    },
    handleAddClick(): void {
      const habitLength = this.habitForm.name.length;
      if (habitLength === 0) {
        this.errorMessage = "Habit name can't be empty";
      } else if (habitLength > 50) {
        this.errorMessage = "Habit name can't be more than 50 characters long";
      } else {
        this.$store.commit("addHabit", { ...this.habitForm });
        this.$router.push("/");
      }
    },
    toggleRepeatsOn(index: number) {
      this.habitForm.repeatsOn[index] = !this.habitForm.repeatsOn[index];
      this.$forceUpdate();
    },
  },
});
